import { useState } from 'react';
import { SharedFile } from 'generated/typescript';
import { viewerURLtoPreviewer } from 'libs/rendering/utils';
import { modalStore } from 'apps/modals/app';
import { ConfirmAction } from 'apps/modals/confirmAction/index';

export type ShareItemProps = {
  cardObject: SharedFile & {
    imageFallbackPath?: string;
    fileSyncConnected?: boolean;
    route: any;
    revisionCount: number;
  };
  cardColumns: number;
  cardApp: Record<string, any>;
  cardNo: number;
};

export const useCommonShare = ({
  cardObject,
  cardApp,
  cardNo,
  cardColumns,
}: ShareItemProps) => {
  const [isVisible, setVisible] = useState(false);

  if (!cardObject) return {};

  const handleMouseOver = () => setVisible(true);
  const handleMouseLeave = () => setVisible(false);

  const handleDeleteBtn = (event: Event) => {
    event.preventDefault();
    event.stopPropagation();
    modalStore.SetModalComponent(ConfirmAction, {
      callBack: () => {
        cardApp.manager.manager.DeleteSharedFile(cardObject);
      },
      title: 'Are you sure you want to delete this Shared File?',
      undo: false,
    });
  };

  const noMargin = (cardNo + 1) % cardColumns === 0;

  const hasPreview =
    cardObject?.revision?.file?.conversionGltfjson?.status === 'SUCCESS';

  const image = {
    completed: false,
    src: hasPreview
      ? viewerURLtoPreviewer(cardObject?.revision?.file?.viewerPath, {
          thumbnail: true,
        })
      : undefined,
  };

  const creatorSpace = cardObject?.creator.profile.inSpace;

  const { sharedFileId } = cardObject.route?.params || {};
  const currentFile = cardApp.upstream.find(
    (node: { id: string }) => node.id === sharedFileId,
  );

  const shouldShowDelete = currentFile?.canDelete;

  return {
    image,
    noMargin,
    hasPreview,
    handleMouseOver,
    handleMouseLeave,
    handleDeleteBtn,
    isVisible,
    creatorSpace,
    currentFile,
    shouldShowDelete,
  };
};
